import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = 'forgot_password_attempts'
const MAX_ATTEMPTS = 3
const WINDOW_MS = 60 * 60 * 1000

export default class extends Controller {
  static targets = ["email", "error", "submit"]

  connect() {
    if (!this.#storageAvailable()) {
      this.submitTarget.disabled = true
      this.#showError('Local storage is required to use this form. Please enable it in your browser settings.')
      return
    }

    if (this.#isRateLimited()) {
      this.submitTarget.disabled = true
      this.#showError('Too many attempts. Please try again in an hour.')
    }
  }

  submit(event) {
    this.#clearError()

    if (!this.#storageAvailable()) {
      event.preventDefault()
      this.submitTarget.disabled = true
      this.#showError('Local storage is required to use this form. Please enable it in your browser settings.')
      return
    }

    if (!this.#validEmail()) {
      event.preventDefault()
      this.#showError('Please enter a valid email address.')
      return
    }

    if (this.#isRateLimited()) {
      event.preventDefault()
      this.submitTarget.disabled = true
      this.#showError('Too many attempts. Please try again in an hour.')
      return
    }

    this.#recordAttempt()
  }

  #storageAvailable() {
    try {
      const test = '__storage_test__'
      localStorage.setItem(test, test)
      localStorage.removeItem(test)
      return true
    } catch {
      return false
    }
  }

  #validEmail() {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailTarget.value.trim())
  }

  #isRateLimited() {
    return this.#recentAttempts().length >= MAX_ATTEMPTS
  }

  #recentAttempts() {
    const now = Date.now()
    const attempts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return attempts.filter(time => now - time < WINDOW_MS)
  }

  #recordAttempt() {
    const recent = this.#recentAttempts()
    recent.push(Date.now())
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recent))
  }

  #showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove('d-none')
  }

  #clearError() {
    this.errorTarget.classList.add('d-none')
    this.errorTarget.textContent = ''
  }
}
